module Shared.Validations.Password

open System
open Illy.SafeStack.SharedValidations
open Illy.SafeStack.Validation
open Illy.SafeStack.CompositionalValidation

type PasswordValidations = 
    | StringValidations of StringValidations
    | IncorrectPassword of customMsg: string option 

module PasswordValidations = 
    let toString = 
        function 
        | StringValidations v -> v.toString()
        | IncorrectPassword customMsg -> Option.defaultValue "Password is incorrect." customMsg
  
let validatePassword password = 
    validate {
        return! (validateString 250 true >-> PasswordValidations.StringValidations) password
    }